module.exports = __webpack_public_path__ + "static/gradientTwo-de1afdcd7bc6de3f60dd68019a7939af.svg";